
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Bestcabserviceinpune() {



  const cardData =
  {
    keyword: '  Best Cab Service in Pune',
    heading: 'Vaishnavi Travels: Best Cab Service in Pune',
    headingDescription: 'Vaishnavi Travels provides professional and affordable Best Cab Service in Pune, catering to all types of travel needs including local rides, airport transfers, outstation trips, weddings, and corporate travel. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage capacity to ensure a safe and comfortable journey for every passenger. With experienced chauffeurs, timely pickups, and flexible booking options, we make travel convenient and stress-free across Pune and nearby destinations. Whether it’s a family outing, business meeting, religious yatra, or weekend getaway, Vaishnavi Travels guarantees reliable, comfortable, and hassle-free cab services in Pune.',

    top: 'Top Places to Visit in Pune with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s grand fort palace and a symbol of Maratha pride. Once the seat of the Maratha Empire, its massive gates, fountains, and courtyards echo with history. Though partially destroyed by fire in 1828, it still draws thousands of visitors daily. The evening light-and-sound show brings alive tales of Bajirao and Mastani. Tourists love exploring its hidden pathways and gardens. Shaniwar Wada is Pune’s crown jewel of heritage and culture."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a monument of national importance linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s personal belongings, photographs, and letters. Its Italian arches and landscaped gardens add serene charm. Students and tourists find it both inspirational and peaceful. Aga Khan Palace is Pune’s proud landmark of patriotism and sacrifice."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is a hilltop stronghold known for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. Trekkers climb to the fort for stunning views of the Sahyadris. The fort still has bastions, temples, and memorials that narrate Maratha valor. In monsoon, mist and waterfalls make the climb enchanting. Local stalls serve rustic pithla-bhakri to visitors. Sinhagad Fort is Pune’s mix of history, trekking, and scenic charm."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The grand idol, adorned with gold and jewels, attracts lakhs of devotees every year. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. Known for its cultural and charitable contributions, it blends faith with service. Devotees feel immense spiritual energy here. Dagdusheth Temple is Pune’s divine and cultural heartbeat."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "The Pataleshwar Cave Temple, carved in the 8th century, is an ancient rock-cut shrine dedicated to Lord Shiva. Massive stone pillars, a sanctum, and a Nandi mandapa highlight its architecture. Despite being in the city center, it offers peace and meditation. Evening chants add to its spiritual aura. History lovers admire its craftsmanship and simplicity. Pataleshwar Cave Temple is Pune’s hidden spiritual heritage gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum is a cultural treasure housing over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. A highlight is the recreated Mastani Mahal, reflecting Maratha romance and history. Students and tourists find the museum highly educational. It preserves centuries of Indian traditions in one place. Raja Dinkar Kelkar Museum is Pune’s proud showcase of culture and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Smaller shrines and a museum nearby add cultural depth. Pilgrims climb 103 steps to reach the temple, blending devotion with scenic charm. Sunrise and sunset views here are captivating. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub for wellness and spirituality. Spread across serene gardens, it attracts seekers from around the world. Meditation sessions, yoga practices, and workshops on personal growth are conducted here. Its Zen gardens and tranquil halls enhance the experience. Beyond spirituality, it is also a rejuvenation retreat. Osho Ashram is Pune’s international destination for peace and mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, also known as the Okayama Friendship Garden, is Pune’s largest landscaped park. Inspired by Japan’s Korakuen Garden, it features streams, bridges, and manicured lawns. Families enjoy picnics, photography, and peaceful walks here. Seasonal flowers and greenery add vibrant charm. It also symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of tranquility."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend retreat near Pune. It supplies water to the city while offering scenic backdrops of hills and flowing waters. During monsoon, the overflowing dam creates a mesmerizing sight. Families gather here for roasted corn and tea at roadside stalls. It also serves as the gateway to Sinhagad Fort. Khadakwasla Dam is Pune’s refreshing natural escape."
  }
],


      "services": [
    {
      "name": "Pune Top Cab Providers",
      "description": "Discover the leading cab providers in Pune offering a wide range of vehicles and services to suit every traveler’s need. These top providers are known for their reliability, professionalism, and customer satisfaction. Whether you need quick local rides, outstation trips, or corporate transportation, these providers ensure safe, timely, and comfortable travel with experienced drivers and well-maintained fleets."
    },
    {
      "name": "Premium Cab Service Pune",
      "description": "Experience luxury and exclusivity with Pune’s premium cab services. Featuring high-end vehicles equipped with plush interiors, advanced amenities, and expert chauffeurs, these cabs cater to discerning travelers who prioritize comfort and style. Perfect for business executives, special events, or those seeking an upscale ride, premium services deliver impeccable professionalism, punctuality, and personalized attention throughout your journey."
    },
    {
      "name": "AC/Non AC Cab Comparison Pune",
      "description": "Understand the benefits of AC and non-AC cabs in Pune to choose the best option for your travel needs. AC cabs offer climate-controlled comfort ideal for hot weather and longer trips, with enhanced interiors and quieter rides. Non-AC cabs provide an economical choice for short distances or budget-conscious travelers while maintaining essential comfort and safety. Our comparison guide helps you make informed decisions based on trip length, budget, and personal preferences."
    },
    {
      "name": "Budget Cab Service Pune",
      "description": "Travel affordably around Pune with our budget cab service designed to offer safe and reliable transportation without breaking the bank. Ideal for students, solo travelers, and everyday commuters, these cabs feature clean, well-maintained vehicles and courteous drivers. Benefit from transparent fare structures, minimal waiting times, and easy booking options, ensuring that budget travel doesn’t mean compromising on quality or service."
    },
    {
      "name": "Reliable Taxi Service Pune",
      "description": "Count on our reliable taxi service in Pune for punctual, safe, and efficient transportation. Our drivers are professional, well-trained, and familiar with city routes, ensuring timely arrivals and smooth rides. Whether it’s daily commuting, airport transfers, or outstation trips, this service focuses on consistency, customer satisfaction, and hassle-free travel experiences, making it one of the most trusted choices in Pune."
    },
    {
      "name": "Corporate Cab Options Pune",
      "description": "Tailored corporate cab services in Pune provide business travelers with professional, discreet, and comfortable transportation solutions. From individual airport pickups to large team outings, corporate cabs offer a range of vehicles including AC sedans, SUVs, and luxury cars. Flexible billing, priority support, and customizable packages make this service ideal for companies looking to streamline employee travel with reliability and class."
    },
    {
      "name": "24×7 Cab Service Pune",
      "description": "Our round-the-clock cab service in Pune guarantees availability whenever you need it, day or night. Whether it’s an early morning airport transfer, a late-night city ride, or an urgent outstation booking, our fleet and drivers are ready to assist with prompt response times and professional service. With 24/7 customer support and flexible booking options, travel with peace of mind any time of the day."
    },
    {
      "name": "Airport Transfer Best Cab",
      "description": "Get the best airport transfer service in Pune with cabs that prioritize punctuality, comfort, and convenience. Our drivers monitor flight schedules to ensure timely pickups and drop-offs, helping you avoid delays or missed flights. Choose from a variety of vehicle types based on your luggage and group size, with added options like meet-and-greet services and flight status updates to enhance your travel experience."
    },
    {
      "name": "Family Travel Cab Options",
      "description": "Family-friendly cab options in Pune provide spacious vehicles equipped with safety features and comfortable seating to accommodate members of all ages. Whether it’s a local outing, airport transfer, or long-distance trip, these cabs offer hassle-free travel with courteous drivers who assist with luggage and ensure smooth journeys. Special packages and flexible scheduling cater specifically to the unique needs of family travelers."
    },
    {
      "name": "Online Cab Service Pune",
      "description": "Book your cab in Pune quickly and securely through our user-friendly online platform. Select your preferred vehicle, schedule your trip, and receive instant confirmation along with transparent fare details. The platform supports easy cancellations, modifications, and 24/7 customer support, ensuring a seamless experience from booking to journey completion. Ideal for tech-savvy travelers seeking convenience and efficiency."
    },
    {
      "name": "App based Taxi Pune",
      "description": "Utilize app-based taxi services in Pune that offer on-demand rides with real-time tracking, digital payments, and driver ratings for enhanced safety and convenience. These services connect you instantly with nearby drivers, provide estimated fares upfront, and allow easy trip management through intuitive mobile apps. Perfect for urban commuters and tourists, app-based taxis combine technology and comfort for a modern travel experience."
    },
    {
      "name": "Mini Cab Service Pune",
      "description": "Mini cab services in Pune are perfect for solo travelers or small groups looking for economical and efficient rides within the city. These compact vehicles offer quick navigation through traffic, easy parking, and lower fares without sacrificing safety or comfort. Ideal for short trips, airport drop-offs, or quick errands, mini cabs provide a convenient and budget-friendly urban transport solution."
    },
    {
      "name": "Best Rated Cab Service Pune",
      "description": "Choose from the best rated cab services in Pune, known for exceptional customer feedback, punctuality, and driver professionalism. These services maintain high standards of vehicle cleanliness, safety, and customer care. With transparent pricing, user-friendly booking systems, and responsive support teams, the best rated cabs in Pune provide a consistently superior travel experience whether for daily commutes or special occasions."
    }
  ],
  "tableData": [
    ["Pune Top Cab Providers", "Premium Cab Service Pune"],
    ["AC/Non AC Cab Comparison Pune", "Budget Cab Service Pune"],
    ["Reliable Taxi Service Pune", "Corporate Cab Options Pune"],
    ["24×7 Cab Service Pune", "Airport Transfer Best Cab"],
    ["Family Travel Cab Options", "Online Cab Service Pune"],
    ["App based Taxi Pune", "Mini Cab Service Pune"],
    ["Best Rated Cab Service Pune"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Best Cab Service in Pune",
    "WhyChoosedescription": "Vaishnavi Travels offers the best cab services in Pune, providing safe, reliable, and comfortable rides for all your travel needs."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from a variety of vehicles including Swift Dzire, Ertiga, Innova, Urbania, and Tempo Traveller to suit your group size and preferences."
  },
  {
    "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
    "WhyChoosedescription": "Our fleet is regularly serviced and sanitized to ensure hygiene and safety throughout your journey."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our skilled drivers are well-trained, courteous, and knowledgeable about Pune’s routes to ensure a smooth travel experience."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We offer competitive, all-inclusive pricing with no hidden charges, covering fuel, tolls, parking, and driver allowances."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop-off Locations",
    "WhyChoosedescription": "Enjoy convenient door-to-door service from your home, hotel, or office anywhere in Pune."
  },
  {
    "WhyChooseheading": "Ideal for All Travel Needs",
    "WhyChoosedescription": "Perfect for local travel, airport transfers, corporate trips, family outings, and group tours."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Hassle-Free Booking",
    "WhyChoosedescription": "Our customer support team is available round-the-clock to assist you with bookings, itinerary planning, and travel inquiries."
  }
]




















  }




const faqData = [
  [
    {
      question: 'Why is Vaishnavi Travels considered one of the best cab services in Pune?',
      answer: 'Vaishnavi Travels is known for its punctual service, well-maintained vehicles, professional drivers, and transparent pricing, making it a top choice for both local and outstation travel from Pune.',
    },
    {
      question: 'What types of cab services does Vaishnavi Travels offer in Pune?',
      answer: 'We offer local hourly rentals, airport transfers, outstation trips, and multi-day packages. Vehicle options range from Swift Dzire to Innova and Tempo Travellers.',
    },
    {
      question: 'Is Vaishnavi Travels suitable for airport pickups and drop-offs in Pune?',
      answer: 'Yes, we provide timely and reliable airport cab services to and from Pune Airport with real-time tracking and fixed pricing.',
    },
    {
      question: 'How does Vaishnavi Travels ensure passenger safety and comfort?',
      answer: 'All our vehicles are regularly sanitized, our drivers are verified and trained, and we provide 24/7 customer support to ensure a smooth and secure travel experience.',
    },
    {
      question: 'Are the cab fares with Vaishnavi Travels competitive?',
      answer: 'Absolutely! We offer some of the most competitive rates in Pune with no hidden charges. All fares are communicated clearly before the trip.',
    },
    {
      question: 'Can I schedule or pre-book a cab with Vaishnavi Travels?',
      answer: 'Yes, advance bookings are available and recommended for airport trips and outstation travel to ensure vehicle availability and timely pickup.',
    },
    {
      question: 'Is Vaishnavi Travels available during late night or early morning hours?',
      answer: 'Yes, we operate 24/7. Whether it’s a midnight airport drop or an early morning pilgrimage, we’ve got you covered anytime.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Kunal Joshi",
    position: "Business Traveler",
    feedback:
      "Vaishnavi Travels is hands-down one of the best cab services in Pune. Clean car, polite driver, and they arrived exactly on time. Ideal for my frequent airport transfers.",
    rating: 5,
  },
  {
    name: "Ms. Sneha Mehta",
    position: "Local Commuter",
    feedback:
      "I’ve used many cab services in Pune, but Vaishnavi Travels stood out. Very professional service, reasonable pricing, and the cab was in great condition.",
    rating: 5,
    style: "style-2",
  }
];













































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];

const bestCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Best Cab Service in Pune",
  "description": "Top-rated cab providers in Pune offering premium AC and non-AC taxis, budget-friendly options, reliable airport transfers, corporate travel, and 24x7 online booking for family and business trips.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Vaishnavi Travels",
    "telephone": "+91-9765685295",
    "url": "https://vaishnavitravel.com/best-cab-service-pune"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "availability": "https://schema.org/InStock",
  "serviceType": [
    "Premium Cab Service",
    "Budget Cab Service",
    "Airport Transfer",
    "Corporate Cab Service",
    "Family Travel Cab",
    "App-based Taxi"
  ]
};




  return (
    <div>

<Helmet>
  <title>Best Cab Service in Pune | Premium & Budget Taxi Providers</title>
  <meta
    name="description"
    content="Top-rated cab providers in Pune offering premium AC and non-AC taxis, budget-friendly options, reliable airport transfers, corporate travel, and 24x7 online booking for family and business trips."
  />
  <meta
    name="keywords"
    content="Pune Top Cab Providers, Premium Cab Service Pune, AC/Non AC Cab Comparison Pune, Budget Cab Service Pune, Reliable Taxi Service Pune, Corporate Cab Options Pune, 24×7 Cab Service Pune, Airport Transfer Best Cab, Family Travel Cab Options, Online Cab Service Pune, App based Taxi Pune, Mini Cab Service Pune, Best Rated Cab Service Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(bestCabServiceSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bestcabserviceinpune;